// 线程池
var pool = []
let tasks = []
var relust = false
/**
 * 把任务添加到线程池
 * @param {objeck} task 任务
 */
function addTask(task){
	pool.push(task)
	if((task != []) && (task)){
		console.log(task)
		task.then(res =>{
			console.log(pool.indexOf(task))
			pool.splice(pool.indexOf(task),1)
		})
	}
	
}
// 跑完一个任务加塞下一个任务
function run(race,tasks,callback){
	let tasks_2 = tasks
	race.then(
		res => {
			let task = tasks_2.shift()
			if(relust){
				callback()
			}
			if(task !== undefined){
				addTask(task)
				run(Promise.race(pool),tasks_2,callback)
			}
			if(tasks_2.length == 0){
				relust = true
				// callback()
			}
		}
	).catch(
		err => {
			console.log(err,'我执行失败')
		}
	)
}
/**
 * 创建线程池并执行
 * @param {Object} tasks		需要跑的任务
 * @param {Object} maxthread	最大线程数
 * @param {Function} callback   上传完成的回调函数
 */
export function createPoolAndRunTask(tasks,maxthread,callback){
	// let pool = []
	// let tasks_2 = tasks
	let maxthread_2 = maxthread
	// 塞满线程池
	// while (pool.length < maxthread_2) {
	//     let task = tasks_2.shift();
	// 	if(task){
	// 		addTask(task,pool)
	// 	}
	// }
	for(let i=0;i<maxthread_2;i++){
		let task = tasks.shift()
		if(task){
			addTask(task,pool)
		}
	}
	let race = Promise.race(pool)
	run(race,tasks,callback)
}


// WEBPACK FOOTER //
// ./src/utils/pool.js